import React, { useRef, useCallback } from 'react';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import QuickPinchZoom, { make3dTransformValue } from "react-quick-pinch-zoom";

const ImagePopupComponent = props => {
    const { isShowImagePopup, onClickBtnCloseImagePopup, info, selectedImageIdx,
        toggleImageSize, isShowOriginalSize } = props;

    const imgRef = useRef();
    const onUpdate = useCallback(({ x, y, scale }) => {
        const { current: img } = imgRef;

        if (img) {
            const value = make3dTransformValue({ x, y, scale });

            img.style.setProperty("transform", value);
        }
    }, []);

    return (
        <div class={`modal-image-popup ${isShowImagePopup ? "on" : ""}`}>
            <div class={`content ${isShowOriginalSize ? "original" : ""}`}>
                <div class="body">
                    {isShowOriginalSize}
                    <button
                        onClick={onClickBtnCloseImagePopup}
                        class="btn-close-modal">
                        <i></i>
                    </button>
                    <div
                        onClick={toggleImageSize}
                        class="img">
                        <img
                            src={info.imageUrlList[selectedImageIdx]}
                            alt={info.name} />
                    </div>
                    <div class='img-mb'>
                        <TransformWrapper
                            options={{
                                limitToBounds: true,
                                limitToWrapper: true,
                                centerContent: true
                            }}
                        >
                            <TransformComponent
                                centerContent={false}>
                                <div className='img'
                                    style={{
                                        backgroundImage: `url("${info.imageUrlList[selectedImageIdx]}")`
                                    }}>
                                    {/* <img
                                        src={info.imageUrlList[selectedImageIdx]}
                                        alt={info.name} /> */}
                                </div>
                            </TransformComponent>
                        </TransformWrapper>
                        {/* <QuickPinchZoom onUpdate={onUpdate}>
                            <img ref={imgRef} src={info.imageUrlList[selectedImageIdx]} />
                        </QuickPinchZoom> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ImagePopupComponent